import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "react-router-dom";
import Table from "../components/Table";
import filePDF from "../assets/images/file-pdf.svg";
import api from "../utils/api";
import FundsCard from "../components/FundsCard";
import PdfDownloader from "../components/PdfDownloader";
import TableSorting from "../components/TableSorting";
import ErrorComp from "../components/ErrorComp";

const FinancePensionWithChart = (props) => {
  const [tableHeader, setTableHeader] = useState(
    window.innerWidth < 767
      ? [
          { label: "חברת ביטוח", sortable: false, engTrns: "logo" },
          { label: "מספר פוליסה", sortable: true, engTrns: "field1" },
          { label: "", sortable: false, engTrns: "field9" },
          { label: "סוג פוליסה", sortable: true, engTrns: "field2" },
          { label: "סטטוס", sortable: true, engTrns: "field3" },
          { label: "סוג קרן פנסיה", sortable: true, engTrns: "field11" },
          { label: "הפקדות השנה", sortable: false, engTrns: "field4" },
          { label: "הפקדה אחרונה ", sortable: false, engTrns: "field5" },
          { label: "שיעור תשואה ", sortable: false, engTrns: "field6" },
          {
            label: "שיעור דמי ניהול צבירה",
            sortable: false,
            engTrns: "field7a",
          },
          {
            label: "שיעור דמי ניהול הפקדה",
            sortable: false,
            engTrns: "field7b",
          },
          { label: "תאריך נכונות", sortable: false, engTrns: "field10" },
        ]
      : [
          { label: "חברת ביטוח", sortable: false, engTrns: "logo" },
          { label: "מספר פוליסה", sortable: true, engTrns: "field1" },
          { label: "סוג פוליסה", sortable: true, engTrns: "field2" },
          { label: "סטטוס", sortable: true, engTrns: "field3" },
          { label: "סוג קרן פנסיה", sortable: true, engTrns: "field11" },
          { label: "הפקדות השנה", sortable: false, engTrns: "field4" },
          { label: "הפקדה אחרונה ", sortable: false, engTrns: "field5" },
          { label: "שיעור תשואה ", sortable: false, engTrns: "field6" },
          {
            label: "שיעור דמי ניהול צבירה",
            sortable: false,
            engTrns: "field7a",
          },
          {
            label: "שיעור דמי ניהול הפקדה",
            sortable: false,
            engTrns: "field7b",
          },
          { label: "תאריך נכונות", sortable: false, engTrns: "field10" },
          { label: "", sortable: false, engTrns: "field9" },
        ]
  );

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pensionData, setPensionData] = useState(null);
  const [tableHeaderSort, setTableHeaderSort] = useState([
    { key: "name", label: "שם הקופה" },
    { key: "monthly", label: "חודשי" },
    { key: "monthly_sum", label: "12 חודשים אחרונים" },
    { key: "threeYears", label: "3 שנים" },
    { key: "fiveYears", label: "5 שנים" },
    {
      key: "depositmanagementfee",
      label: "דמי ניהול ממוצעים",
      tooltip: "Lorem Ipsum הוא פשוט טקסט דמה של תעשיית הדפוס והקביעה.",
    },
    {
      key: "propertymanagementfees",
      label: "שארפ 5 שנים ",
      tooltip: "Lorem Ipsum הוא פשוט טקסט דמה של תעשיית הדפוס והקביעה.",
    },
    {
      key: "totalAssets",
      label: "היקף נכסים",
      tooltip: "Lorem Ipsum הוא פשוט טקסט דמה של תעשיית הדפוס והקביעה.",
    },
  ]);
  const [yieldDataFirst, setYieldDataFirst] = useState([]);
  const [yieldDataSecond, setYieldDataSecond] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setPensionData(props?.pensionPolicies || []);
        setData(
          (props?.pensionPolicies || [])
            // .filter((item) => item?.duplicate !== true)
            .filter(
              (elem) => elem?.productType == "2" || elem?.productType == "1"
            ) || []
        );
      } catch (err) {
        console.error("error", err);
      } finally {
        if (props?.onboardingStep >= 4) {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [props?.pensionPolicies, props?.onboardingStep]);

  const yielddata = async () => {
    try {
      const UserProfile = await api.get("/policy/yield-data");
      if (UserProfile?.status === 200) {
        setYieldDataFirst(UserProfile?.data?.data || []);
        setYieldDataSecond(UserProfile?.data?.dataFund2 || []);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    yielddata();
  }, []);

  const [UserData, setUserData] = useState({});
  const getUser = async () => {
    setUserData(props?.data || {});
  };

  useEffect(() => {
    if (
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/register"
    ) {
      getUser();
    }
  }, [props?.data]);

  return (
    <>
      <div className="heading-wrap d-flex justify-content-between">
        <div className="heading">
          <div className="head-wrap">
            <Breadcrumbs className="breadcrumbs" aria-label="breadcrumb">
              <Link to="/profile" underline="hover">
                {UserData?.full_name || ""}
              </Link>
              <Typography>
                <b>פנסיה</b>
              </Typography>
            </Breadcrumbs>
            <h1>ברוכים השבים , {UserData?.full_name || ""}</h1>
          </div>
          <div className="btn btn-img pdf_btn">
            <PdfDownloader fileName="financepensionwithchart.pdf">
              <img src={filePDF} alt="" />
            </PdfDownloader>
          </div>
          <p>
            ברוכים הבאים ללוח הבקרה של אובקטיבי <br />
            זהו המרכז שלכם לניהול ושיפור המצב הפיננסי, הפנסיוני והביטוחי שלכם.
            כאן תוכלו למצוא סקירה מקיפה של כל המוצרים והפוליסות שלכם, ביטוחים,
            פנסיה, חסכונות, קרנות, הלוואות, נתוני פרישה, אפשרויות משיכה ועוד..
            הכל כאן ! <br />
            כל אחד מלוחות הבקרה נועד לספק לכם תובנות ברורות והמלצות לפעולה.
            הציצו לעמודים הפנימיים כדי להעמיק בנתונים שלכם, לעקוב אחר ההתקדמות
            ולגלות הזדמנויות לשיפור עתידכם הפיננסי - הכול בפלטפורמה אוביקטיבית
            אחת.
          </p>
        </div>
        <div className="btns-row">
          <div className="btn btn-img pdf_btn">
            <PdfDownloader fileName="financepensionwithchart.pdf">
              <img src={filePDF} alt="" /> הפקת דוח
            </PdfDownloader>
          </div>
        </div>
      </div>
      {props?.onboarding_error == 1 && <ErrorComp />}
      <FundsCard
        pensionData={pensionData}
        onboardingStep={props?.onboardingStep}
        balances={props?.balances}
        from="pension"
      />
      {console.log("data saving Page", data)}
      <Table
        tableHeader={tableHeader}
        data={data}
        from="savingPage"
        title="קרנות פנסיה"
        loading={loading}
        notFoundMessage="פנסיה"
        carrierLogos={props?.carrierLogos}
      />
      <div className="table-main">
        <div className="title d-flex justify-content-between">
          <h2>קופות מקיפות מובילות</h2>
        </div>
        <div className="objective-box d-flex">
          <div className="table-main-left w_100">
            <>
              <TableSorting
                yieldDataFirst={yieldDataFirst}
                tableHeaderSort={tableHeaderSort}
                from="PensionPage"
              />
            </>
          </div>
        </div>
      </div>
      <div className="table-main">
        <div className="title d-flex justify-content-between">
          <h2>קופות משלימות מובילות</h2>
        </div>
        <div className="objective-box d-flex">
          <div className="table-main-left w_100">
            <>
              <TableSorting
                yieldDataFirst={yieldDataSecond}
                tableHeaderSort={tableHeaderSort}
                from="PensionPage"
              />
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default FinancePensionWithChart;
